import "../styles/Terms.css";

export default function Terms() {
  return (
    <div className="terms__container">
      <section className="terms__intro">
        <div>
          <h1>TERMS & CONDITIONS - Bribie Island Picnics Hire</h1>
          <p>
            Please read the following terms and conditions carefully before
            booking with Bribie Island Picnics. By securing a booking, you agree
            to the terms outlined below.
          </p>
        </div>
      </section>

      <section className="terms__content--container">
        <div className="terms__content--details">
          <h2>Booking & Payment</h2>
          <ul>
            <li>
              A $100 non-refundable deposit is required to secure your booking
              date. The remaining balance is due no later than 3 days prior to
              your event.
            </li>
            <li>Bookings are not confirmed until the deposit is received.</li>
            <li>Late payments may result in cancellation of your booking.</li>
          </ul>
        </div>

        <div className="terms__content--details">
          <h2>Cancellations & Refunds</h2>
          <ul>
            <li>
              Cancellations made more than 14 days before the event will receive
              a full refund.
            </li>
            <li>
              Cancellations made within 14 days of the event will forfeit the
              deposit.
            </li>
            <li>
              No refunds will be given for cancellations made within 48 hours of
              the event.
            </li>
          </ul>
        </div>

        <div className="terms__content--details">
          <h2>Weather Policy</h2>
          <ul>
            <li>
              At Bribie Island Picnics, your experience is important to us. As
              all of our picnics are held outdoors, weather conditions can
              sometimes affect your booking.
            </li>
            <li>
              If extreme or unforeseen weather prevents us from setting up your
              picnic safely, we will provide a full refund, excluding the cost
              of any catering & beverages and outsourced furniture hire. As
              these are prepared specifically for your booking.
            </li>
            <li>
              Once your picnic has been set up and you have arrived, any
              interruption or early conclusion due to unexpected weather is
              non-refundable.
            </li>
            <li>
              We closely monitor weather conditions leading up to your booking
              and will contact you if we believe the weather will prevent your
              picnic from going ahead safely.
            </li>
            <li>
              Indoor backup options are encouraged and are the client's
              responsibility to arrange with approval from Bribie Island
              Picnics.
            </li>
          </ul>
        </div>

        <div className="terms__content--details">
          <h2>Damage & Bond</h2>
          <ul>
            <li>A security bond may be required for certain hire packages.</li>
            <li>
              The client is responsible for any damage, loss, or theft of Bribie
              Island Picnics property during the hire period.
            </li>
            <li>
              Any damage or excessive cleaning required may be deducted from the
              bond or charged additionally.
            </li>
            <li>No paint, glue or slime may be used on any hired items.</li>
            <li>
              {" "}
              No Craft Activities Please, unless approved in writing by Bribie
              Island Picnics.
            </li>
          </ul>
        </div>

        <div className="terms__content--details">
          <h2>Hire Period</h2>
          <ul>
            <li>Standard hire is upto 3 hours.</li>
            <li>
              Additional hire time must be arranged in advance and may incur
              extra fees.
            </li>
            <li>
              Items must not be moved from their original setup location unless
              discussed with our team.
            </li>
          </ul>
        </div>

        <div className="terms__content--details">
          <h2>Client Responsibility</h2>
          <ul>
            <li>
              The client is responsible for ensuring the site is accessible,
              safe, and suitable for setup.
            </li>
            <li>
              Bribie Island Picnics reserves the right to refuse setup if the
              location is unsafe or unsuitable.
            </li>
            <li>
              Children must be supervised at all times around hired items and
              styling elements.
            </li>
          </ul>
        </div>

        <div className="terms__content--details">
          <h2>Photography & Promotion</h2>
          <ul>
            <li>
              Bribie Island Picnics reserves the right to take photos of your
              picnic setup for marketing purposes unless otherwise requested in
              writing prior to the event.
            </li>
          </ul>
        </div>

        <div className="terms__content--details">
          <h2>General</h2>
          <ul>
            <li>
              Every picnic hire includes complementary delivery, professional
              setup, and pack-up, so you can simply arrive, relax, and enjoy
              your picnic experience.
            </li>
            <li>
              Remove all bulk rubbish with the garbage bag provided and dispose
              in the nearest bin
            </li>
            <li>Strictly No Smoking</li>
            <li>Pets - BYO pet blanket</li>
            <li>
              You must remain at your booking until we arrive to packup at the
              agreed time. If you need to leave early please telephone us and
              wait for our prompt arrival before leaving.
            </li>
            <li>
              Catering & Fresh Flowers are pre-ordered and are subject to the
              business cancellation conditions.
            </li>
            <li>All items are HIRE ONLY unless specified</li>
          </ul>
        </div>

        <div className="terms__content--details">
          <h3>
            If you have any questions or need clarification, please don't
            hesitate to contact us before booking.
          </h3>
        </div>
      </section>

      <section className="terms__address--container">
        <address className="terms__address--content">
          <h3>CONTACT</h3>
          <p>Bribie Island Picnics</p>
          <p>Telephone/ SMS 0493 294 665 </p>
          <p>Facebook / Instagram :bribieislandpicnics </p>
        </address>
      </section>
    </div>
  );
}
